import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Card } from "./Card";

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <Card className={cn("flex flex-col items-center justify-center gap-3 py-16 text-center", className)}>
      {icon && <span aria-hidden="true" className="text-text-secondary">{icon}</span>}
      <div>
        <h2 className="text-h4">{title}</h2>
        {description && <p className="mt-1 text-body text-text-secondary">{description}</p>}
      </div>
      {action}
    </Card>
  );
}
